import { render, staticRenderFns } from "./Unidades.vue?vue&type=template&id=3c6b60b2&scoped=true"
import script from "./Unidades.vue?vue&type=script&lang=js"
export * from "./Unidades.vue?vue&type=script&lang=js"
import style0 from "./Unidades.vue?vue&type=style&index=0&id=3c6b60b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6b60b2",
  null
  
)

export default component.exports